import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { usePlatformAuth } from '../contexts/PlatformAuthContext';
import { Box, CircularProgress } from '@mui/material';

export function ProtectedRoute() {
  const { isAuthenticated, loading } = usePlatformAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100dvh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
